import React from "react";
import { testimonials } from "../data/content";
export function Testimonials() {
  return <section id="resultados" className="px-6 py-20 sm:py-28" data-id="element-142" data-mp="3kpuhliymarik">
      <div className="mx-auto max-w-5xl" data-id="element-143" data-mp="3ksgw62jxe7aa">
        <div className="mb-12 text-center" data-id="element-144" data-mp="3fyvykbm8vfbm">
          <p className="mb-4 text-sm font-semibold text-gold" data-id="element-145" data-mp="3fxuittuaa4nk">Resultados reales</p>
          <h2 className="font-serif text-[clamp(30px,4.5vw,46px)] font-bold leading-tight" data-id="element-146" data-mp="3b01gjbw3pusk">
            Alumnos que ya están vendiendo
          </h2>
        </div>

        <ul className="grid gap-4 md:grid-cols-2" data-id="element-147" data-mp="31zd24g2spsf5">
          {testimonials.map(t => <li key={t.name} className="flex flex-col rounded-xl border border-line bg-ink-3 p-6 sm:p-7" data-id="element-148" data-mp="2x0jqyuazedi5">
              <p className="mb-4 font-serif text-[22px] font-bold leading-snug text-gold" data-id="element-149" data-mp="2s28bo41x3asj">{t.result}</p>
              <blockquote className="mb-6 text-[15px] leading-relaxed text-soft" data-id="element-150" data-mp="v9oojjm9rg2g">“{t.quote}”</blockquote>
              <div className="mt-auto flex items-center gap-3 border-t border-line pt-5" data-id="element-151" data-mp="qa3mv1fpstm1">
                <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full text-base font-bold text-white" style={{
              backgroundColor: t.color
            }} aria-hidden="true" data-id="element-152" data-mp="h5os1hpjsial">
                  {t.initial}
                </span>
                <div data-id="element-153" data-mp="c7wpltra1ds5">
                  <p className="text-sm font-semibold text-white" data-id="element-154" data-mp="c7dfv0bs5vp7">{t.name}</p>
                  <p className="text-xs text-muted" data-id="element-155" data-mp="zxhawjawkn4l">{t.meta}</p>
                </div>
              </div>
            </li>)}
        </ul>
      </div>
    </section>;
}